module.exports = __webpack_public_path__ + "static/media/slingshot 2020.357784e3.usdz";